import styled, { keyframes } from "styled-components";

import { colors, globalStyle } from "global/globalStyle";

import {
  IDirectionHorizontalToast,
  IDirectionVerticalToast,
} from "./interface";

interface IProps {
  type: "success" | "warning" | "error";
  directionVertical?: IDirectionVerticalToast;
  directionHorizontal?: IDirectionHorizontalToast;
}

const color: any = {
  success: globalStyle.toast.success,
  warning: globalStyle.toast.warning,
  error: globalStyle.toast.error,
} as any;

const appearFromLeft = keyframes`
  from {
    opacity: 0;
    position: absolute;
    transform: translateX(125%);
  }
  to{
    opacity: 1;
    position: relative;
    transform: translateX(0);
  }
`;

export const Container = styled.div<IProps>`
  width: 300px;
  display: flex;
  justify-content: flex-end;
  padding: 4px;
  border-radius: 8px;
  background: ${({ type }) => color[type]};
  margin-bottom: 8px;
  animation: ${appearFromLeft} 0.5 s;

  position: absolute;
  z-index: 20;
  margin: 10px;

  ${(props) =>
    props.directionVertical === "Botton"
      ? "botton: 0"
      : props.directionVertical === "Top"
        ? "top: 0"
        : ""};

  ${(props) =>
    props.directionHorizontal === "Left"
      ? "left: 0"
      : props.directionHorizontal === "Right"
        ? "right: 0"
        : ""};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 248px;
  border-radius: 0 8px 8px 0;
  background: ${colors.default_base_white};
  padding: 24px;

  span {
    font-family: ${globalStyle.fontFamily};
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    margin-top: 14px;
  }
`;

export const TitleContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  strong {
    font-family: ${globalStyle.fontFamily};
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
  }

  svg {
    cursor: pointer;
  }
`;
